/**
 * Usually used in conjunction with front-end price calculations (which should be avoided).
 * TODO do not use this function.
 * @param {number} value - price value fond in `price.value`.
 * @returns {string}
 */
export default function unreliablyFormatRublesPrice(value) {
  // Same as in `zenky-admin-ui`'s `formatPriceRub`
  return (value / 100).toLocaleString(undefined, {
    currency: 'RUB',
    style: 'currency',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
}
